import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Loading from 'vue-loading-overlay';
import { VueEditor } from "vue2-editor";
import Vuex from 'vuex'
import store from './store';
import mixpanel from 'mixpanel-browser'
import VueGtag from "vue-gtag";
mixpanel.init("82f865ca6fe644d9992fdc48b44e2c2a");

Vue.config.productionTip = false

import './parse'
import './table'
import './components'
import './subComponents'
import './moment'
import './plugin/Currency'
import './plugin/Arabic'
//import style
import './assets/main.scss';
import './assets/componentStyle/horganice-cid-reader.scss'
import "vue-loading-overlay/dist/vue-loading.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(Loading)
Vue.use(VueGtag, {
  config: { id: "G-982W5K28JZ" }
})
Vue.component('vue-editor', VueEditor)

Vue.prototype.$sessionToken = ""
Vue.prototype.$user = null
Vue.prototype.$apartmentId = ""
Vue.prototype.$apartment = null
Vue.prototype.$adminUser = process.env.VUE_APP_ADMIN_USER
Vue.prototype.$adminPass = process.env.VUE_APP_ADMIN_PASS
Vue.prototype.$mixpanel = mixpanel
Vue.prototype.$webAppUrl = process.env.VUE_APP_WEBAPP_URL
Vue.config.errorHandler = function(err, vm, info) {
  console.log(err);
  if (err.message === 'invalid session token') {
    localStorage.removeItem(`Parse/${process.env.VUE_APP_APP_KEY}/currentUser`)
    setTimeout(() =>{
      window.location.href = window.location.origin
    },200)
  }
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
